// @ts-check

import store from 'redux/store';

/**
 * Best-effort snapshot of the current user, used to stamp CreatedBy / UpdatedBy
 * on template writes. Read straight from the redux userInfo slice so API calls
 * can attach it without threading it through every component.
 *
 * The backend prefers its own session identity (req.identity) and only falls
 * back to these values, so a missing/empty user here is harmless.
 *
 * @returns {{ user_id: number|null, user_name: string|null }}
 */
function getCurrentActor() {
	try {
		const userInfo = store.getState()?.userInfo?.userInfo;
		const idNum = userInfo?.userId ? parseInt(userInfo.userId, 10) : NaN;
		return {
			user_id: Number.isFinite(idNum) && idNum > 0 ? idNum : null,
			user_name: userInfo?.fullname || userInfo?.username || null,
		};
	} catch {
		return { user_id: null, user_name: null };
	}
}

export default getCurrentActor;
